export const transformPricingTable = pricingTable => {
  const transformed = {
    rooms: [],
    seasons: [],
    extras: {},
    extraNightRate: {
      amount: 150,
      currency: "EUR",
    },
  }

  if (!pricingTable?.length) return transformed

  const table = pricingTable[0]
  const roomLabels = table.columns.map(col => col.name)
  transformed.rooms = roomLabels

  table.rows.forEach(row => {
    const hasAmounts = row.cells.some(cell => cell?.value?.amount)
    const isSeason = row.name?.includes("to") && !row.merge
    const isExtra = row.merge === true && hasAmounts

    if (isSeason) {
      const rates = {}
      row.cells.forEach((cell, colIndex) => {
        const roomLabel = roomLabels[colIndex]
        if (roomLabel) {
          rates[roomLabel] = {
            amount: cell?.value?.amount || 0,
            currency: cell?.value?.currency?.code || "EUR",
          }
        }
      })

      const [startStr, endStr] = row.name.split(" to ")
      const start = new Date(startStr + " UTC").toISOString().split("T")[0]
      const end = new Date(endStr + " UTC").toISOString().split("T")[0]

      transformed.seasons.push({
        label: row.name,
        start,
        end,
        rates,
      })
    }

    if (isExtra) {
      const priceCell = row.cells.find(cell => cell?.value?.amount)
      const currency = priceCell?.value?.currency?.code || "EUR"
      const amount = priceCell?.value?.amount || 0

      transformed.extras[Object.keys(transformed.extras).length] = {
        label: row.name,
        amount,
        currency,
      }
    }
  })

  return transformed
}
